// @flow
import React from 'react'
import { Toast } from '@ifchange-eui-mobile/eui-mobile'
import Icon from '@components/Icon'
import { encodeUrlSearch } from '@utils/unit'
import { request, config } from '../index'

declare type ResponsePackFormat = 'legacy' | 'old' | 'new'

export default class Service {
  baseUrl: { ['dev' | 'gqc' | 'prd']: string }

  responsePackFormat: ResponsePackFormat

  constructor () {
    this.responsePackFormat = 'new'
  }

  setup (): Promise<void> {
    return Promise.resolve()
  }

  url (path: string): string {
    return `${this.baseUrl[config.env]}${path}`
  }

  request (path, method, data, header, loading: false, cross: false) {
    const defaultHeader = { 'Content-Type': 'application/json', Accept: 'application/json' }
    const finalData = { ...data }
    const finalHeader = Object.assign(defaultHeader, header)

    Object.keys(finalData).forEach(
      key => (finalData[key] === null || !finalData[key]) && delete finalData[key]
    )
    Object.keys(finalHeader).forEach(
      key => (finalHeader[key] || !finalData[key] === null) && delete finalHeader[key]
    )
    const url = this.url(path)
    const promise = request.request(url, method, finalData, finalHeader, cross)
    return this.unpackResponse(promise, loading)
  }

  unpackResponse (promise) {
    return promise.then(res => {
      const wxStatusCode = res.status
      if (wxStatusCode < 400) {
        if (res.ok) {
          return res.json().then(wxData => {
            /**
             * err_no 说明:
             * => 1: 报错, ResponseMsg显示给用户
             * => 0: 数据返回成功
             * => -1: 报错, ResponseMsg不显示
             */
            const { err_msg, err_no } = wxData
            if (err_no === '0') {
              return wxData.results
            }

            if (err_no === '250015') {
              Toast.success({
                content: '身份校验过期，请重新登录',
                icon: <Icon type='warning' size={34} />,
                duration: 1
              })
              return setTimeout(() => {
                const redirect = encodeUrlSearch()

                const currentPath = window.location.pathname
                if (currentPath !== '/login') {
                  History.push(`/login?redirect=${redirect}`)
                }
              }, 1000)
            }

            Toast.success({
              content: err_msg,
              icon: <Icon type='warning' size={34} />,
              duration: 1
            })

            const error = { err_no, err_msg }
            return Promise.reject(error)
          })
        }
        console.log("Looks like the response wasn't perfect, got status", res.status)

        // return Promise.reject(new Error(res.statusText))
        return Toast.success({
          content: res.statusText,
          icon: <Icon type='warning' size={34} />,
          duration: 1
        })
      }
      // return Promise.reject(new Error(res.statusText))
      return Toast.success({
        content: res.statusText,
        icon: <Icon type='warning' size={34} />,
        duration: 1
      })
    })
  }
}
